module.exports = __webpack_public_path__ + "img/nolan-id-verified.962ba2d0.svg";